<!-- <div class="container">
    <h3>Sub-base Coverage </h3>
    <div class="col-md-4">
        <label class="form-label form-control-sm">The area to be covered is..</label>
            <input type="text" placeholder=""  class="form-control"> square metres and the compacted sub-base should be
            <input type="text" placeholder="" class="form-control">  millimetres thick/deep
    </div>
    <hr>
    <div class="col-md-4 mt-3">
            <button type="button" class="btn btn-success">Work it Out</button>
    </div>
    <div class="col-md-3">
        You will need approximately <input type="text" placeholder="" class="form-control">  T of DTp1
    </div>
</div> -->


<h3>Sub-base coverage </h3>
<div class="calculator-inner calc-col1">
    <div class="calc-fields">
        <div class="inline-label-fields">
            <label class="form-label">
                <span> The area to be covered is <input type="text" placeholder="" class="form-control">
                    square metres and the compacted sub-base should be
                    <input type="text" placeholder="" class="form-control">millimetres thick/deep
                </span>
            </label>
        </div>
        <p class="work-it-out-btn"><button type="button" class="btn-success">Work it Out</button></p>
        <div class="inline-label-fields">
            <label class="form-label"><span>You will need approximately <input type="text" placeholder="" class="form-control"> T of DTp1</span></label>
        </div>
    </div>
</div>